import type {FetchEmploymentResponse} from '../../http';
import {fetchEmployment} from '../../http';
import {useQuery, type UseQueryOptions} from 'react-query';

export function useFetchEmployment(options?: UseQueryOptions<FetchEmploymentResponse>) {
	return useQuery<FetchEmploymentResponse>({
		queryKey: ['employment'],
		queryFn: async ({signal}) => {
			const {data} = await fetchEmployment(signal);

			return data;
		},
		...options,
	});
}
